/**
 * Access token storage.
 *
 * The access token is kept ONLY in memory (a module-level variable), never in
 * localStorage/sessionStorage. This protects it from being read by any injected
 * script (XSS) that scans web storage.
 *
 * Persistence across page reloads is achieved through the httpOnly refresh-token
 * cookie: on startup the app silently calls /api/auth/refresh to obtain a fresh
 * access token (see AuthContext.initializeAuth).
 */

let accessToken = null;

const tokenStorage = {
  /**
   * Get the current access token
   * @returns {string|null} Access token or null
   */
  get() {
    return accessToken;
  },

  /**
   * Store the access token
   * @param {string} token - Access token to store
   */
  set(token) {
    accessToken = token;
  },

  /**
   * Remove the access token
   */
  clear() {
    accessToken = null;
  },
};

export default tokenStorage;
